import { Button } from "@mui/material";
import {  Modal } from "react-bootstrap";

interface IModalCreateVersionComponentProps {
    show: boolean,
    toggleShow: () => void,
    setCreateMethod: React.Dispatch<React.SetStateAction<string>>,
}

const ModalCreateVersionComponent = (props: IModalCreateVersionComponentProps) => {
    const handleClose = () => {
        props.setCreateMethod("");
        props.toggleShow();
    }

    const handleCloseWithResponse = (method: string) => {
        props.setCreateMethod(method);
        props.toggleShow();
    }

    return (
        <Modal size="lg" show={props.show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Criar versão de análise</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <span>Como gostria de criar a versão de análise?</span>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div className='d-flex align-items-center text-nowrap justify-content-start w-100'>
                    <Button variant="contained" className='btn btn-primary w-100 me-2' onClick={() => handleCloseWithResponse("blank")}>
                        Gerar versão em branco
                    </Button>
                    <Button variant="outlined" className='btn btn-secondary w-100 ms-2' onClick={() => handleCloseWithResponse("historic")}>
                        Gerar versão a partir da selecionada
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
    )
}

export default ModalCreateVersionComponent;